// extracted by mini-css-extract-plugin
export default {"display":"style_display__AxqNs"};